import { get, isEmpty } from 'lodash';

import { ERROR_CODES } from 'core/constants';

/**
 * @description This extracts the error details from the error object
 * @param error - error object from catch block
 * @returns object contains error extracted details
 */
export const extractApiErrorObject = (error: unknown) => {
	const mobileRestrictedErrCode = get(
		error,
		'data.error_sub_code',
		ERROR_CODES.MOBILE_RESTRICTED,
	);

	const moreInfoObject = get(error, 'data.more_info');

	const mobileRestrictedEndDate =
		!isEmpty(moreInfoObject) === true
			? JSON.parse(moreInfoObject)?.restriction_end_date
			: new Date().toDateString();

	return {
		hasValidErrorCode:
			mobileRestrictedErrCode === ERROR_CODES.MOBILE_RESTRICTED &&
			!isEmpty(moreInfoObject) &&
			!isEmpty(mobileRestrictedEndDate),
		mobileRestrictedEndDate,
	};
};
